import { useGetFleet } from 'features/fleets/hooks/useGetFleet';
import { useParams } from 'react-router-dom';

export function FleetBreadcrumb() {
  const { fleetId = '' } = useParams();
  const { fleet } = useGetFleet(fleetId);

  return fleet?.name ?? fleetId;
}
